/* unplugin-vue-components disabled */import { render } from "./meeting-info.vue?vue&type=template&id=ec4944e0&scoped=true"
import script from "./meeting-info.vue?vue&type=script&lang=js"
export * from "./meeting-info.vue?vue&type=script&lang=js"

import "./meeting-info.vue?vue&type=style&index=0&id=ec4944e0&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec4944e0"],['__file',"src/components/cards/meeting/meeting-info.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ec4944e0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ec4944e0', __exports__)) {
    api.reload('ec4944e0', __exports__)
  }
  
  module.hot.accept("./meeting-info.vue?vue&type=template&id=ec4944e0&scoped=true", () => {
    api.rerender('ec4944e0', render)
  })

}


export default __exports__